import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

export const MiniAppRouter = ({ children }: { children: React.ReactNode }) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <Redirect to="home" />
        </Route>
        <Route path="/:pagePath">{children}</Route>
      </Switch>
    </BrowserRouter>
  );
};
